// Datos de ciclo escolar, caso especofico.
// Activará un caso especifico en la aplicación. En la vista de Evaluaciones, los datos se fíltrarán usando estos datos para los usuarios especificos

import { _APP_DATA } from "../../data/AppData";


interface ICicloEscolarEvaluarCaso {
    _description: string;
    _idsUsuariosAplicar: number[];
    _aplicarCaso(): boolean;
    Id: number;
    IdEscuela: number;
    Nombre: string;
    FechaInicio: string; // ISO
    FechaFin: string; // ISO
}


const caso_produccion: ICicloEscolarEvaluarCaso = {
    _description: "Caso Agora (de la organización Mimos y Agora) para evaluar el ciclo escolar 2024-2025",
    _idsUsuariosAplicar: [
        7727, //: msaavedramimospolanco@gmail.com
        7256, //: raucagora@gmail.com
    ],
    _aplicarCaso() {
        const userId = _APP_DATA.userData.IdUsuario;
        return this._idsUsuariosAplicar.includes(userId);
    },
    Id: 137,
    IdEscuela: 102, // Agora
    Nombre: "24 - 25",
    FechaInicio: "2024-08-01T06:00:00Z",
    FechaFin: "2025-08-31T06:00:00Z",
};
const caso_desarrollo: ICicloEscolarEvaluarCaso = {
    _description: "Este es un caso específico para evaluar el ciclo escolar 2024-2025",
    _idsUsuariosAplicar: [44],
    _aplicarCaso() {
        const userId = _APP_DATA.userData.IdUsuario;
        return this._idsUsuariosAplicar.includes(userId);
    },
    FechaFin: "2025-08-08T06:00:00Z",
    FechaInicio: "2025-03-21T06:00:00Z",
    Id: 72,
    IdEscuela: 4,
    Nombre: "Primavera - Verano (2025)",
}

export const _CICLO_ESCOLAR_CASO: ICicloEscolarEvaluarCaso = import.meta.env.DEV
    ? caso_desarrollo
    : caso_produccion;